<template>
    <div class="d-flex flex-column position-relative">

        <div class="position-relative ml-auto">
            <button class="btn btn-success ml-auto my-2" type="button" @click="addUntestedForm()" :disabled="!canAddMoreGroups">
                <i class="fa fa-plus-circle mr-1"></i>
                Add Reference Form
            </button>
        </div>

        <div class="card panel panel-body p-0 mb-2 position-relative" v-for="(test, index) in sampleTests">
            <div v-text="(index + 1)" class="badge badge-secondary position-absolute" style="top: 1.5rem; right: 1rem"></div>
            <sample-untested-demand-response-group  :project="project"
                                                    :spaces="spaces"
                                                    :spaces-taken="spacesTaken"
                                                    :test="test"
                                                    :demand-response="demandResponse">
            </sample-untested-demand-response-group>
        </div>

    </div>
</template>
<script>
export default {

    props:['project'],

    data() {
        return {
            sampleTests: [],
            demandResponse: null,
            spaces: [],
        }
    },

    created() {
        App.request().get(`/projects/${this.project.slug}/sample-demand-response-spaces`)
            .then(response => {
                this.demandResponse = response.data.test
                this.loadUntestedForms(response.data.tests)
                this.spaces = response.data.spaces
            })
            .catch(error => {
                console.log(error)
            })
    },

    methods: {

        loadUntestedForms(untested_forms) {
            this.sampleTests = untested_forms

            if (this.sampleTests.length == 0) {
                this.addUntestedForm()
            }
        },

        addUntestedForm() {
            this.sampleTests.push({
                id: this.demandResponse.id,
                untested_forms: [],
                data: {
                    space_id: null
                },
            })
        },
    },

    computed: {
        spacesTaken() {
            return []
            // return _.uniq(this.sampleTests.map(test => {
            //     return test.data ? test.data.space_id : null;
            // }))
        },

        canAddMoreGroups() {
            return true;
            // return this.sampleTests.filter(test => {
            //     return (test.data && test.data.space_id == null) || test.id == null;
            // }).length == 0;
        }
    }
}
</script>
